import { computePosition, shift, offset } from "@floating-ui/dom";

class Popover extends HTMLElement {
  connectedCallback() {
    this.button = this.getElementsByTagName("button")[0];

    const popoverId = this.button.getAttribute("aria-describedby");
    this.target = document.getElementById(popoverId);

    this.isOpen = false;

    this.button.addEventListener("click", (event) => {
      event.stopPropagation();
      this.classList.toggle("visible");
      this.isOpen ? this.closePopover() : this.openPopover();
    });
  }

  openPopover() {
    this.isOpen = true;

    computePosition(this.button, this.target, {
      placement: "bottom",
      middleware: [shift({ padding: 5 }), offset(6)],
    }).then(({ x, y }) => {
      Object.assign(this.target.style, {
        left: `${x}px`,
        top: `${y}px`,
      });
    });

    // a cheap click outside function
    document.addEventListener("click", () => this.closePopover(), { once: true });
  }

  closePopover() {
    this.isOpen = false;
    this.classList.remove("visible");
  }
}

customElements.define("sitediver-popover", Popover);
